import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { transition } from '../../../shared/style-settings'

export const useSimilarNonprofitsComponentStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(3),
      alignItems: 'center',
    },
    similarNonprofitsSearchLink: {
      textDecoration: 'none',
      color: 'black',
    },
    sliderHolder: {
      position: 'relative',
      [theme.breakpoints.down('sm')]: {
        display: 'block',
        padding: '0',
      },
    },
    // Embla Carousel styles
    embla: {
      //width: '90%',
      //marginLeft: '5%',
      overflowX: 'hidden',
      position: 'relative',
    },
    emblaContainer: {
      display: 'flex',
      touchAction: 'pan-y',
      paddingBottom: "5px"
    },
    emblaSlide: {
      flex: '0 0 auto',
      minWidth: 0,
      //height: '140px',
      paddingRight: '2%',
      // Maximum 3 slides visible
      // Extra large and large screens: 3 slides
      width: 'calc(101% / 3)',
      [theme.breakpoints.down('md')]: {
        // Medium screens: 2 slides
        width: 'calc(101% / 2)',
      },
      [theme.breakpoints.down('sm')]: {
        // Small screens: 2 slides
        width: 'calc(101% / 2)',
      },
      [theme.breakpoints.down('xs')]: {
        // Extra small screens: 1 slide
        width: 'calc(101% / 1)',
      },
    },
    emblaButton: {
      position: 'absolute',
      top: '58%',
      color: 'black',
      border: 'none',
      borderRadius: '50%',
      backgroundColor: 'transparent',
      height: 50,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: transition,
      '&:hover': {
        //transform: 'translateY(-50%) scale(1.1)',
      },
      '&:disabled': {
       cursor: 'not-allowed',
      },
      [theme.breakpoints.down('sm')]: {
        width: 40,
        height: 40,
      },
    },
    emblaButtonPrev: {
      left: -50,
      top: '49%',
      [theme.breakpoints.down(1300)]: {
        display: 'none',
      },
    },
    emblaButtonNext: {
      right: -50,
      top: '49%',
      [theme.breakpoints.down(1300)]: {
        display: 'none',
      },
    },
    bold: {
      fontWeight: 'bold',
    },
    section: {
      marginTop: '3em',
    },
  })
)
